module.exports = __webpack_public_path__ + "img/ad-verification.1b2bf6c8.svg";